import { type ReactElement, useState } from 'react'
import { isNotDefined, type NotificationView } from '@terros/common'
import { ActionIcon, Indicator, Popover } from '@mantine/core'
import { SizePrimitives, useNotificationUnreadCount } from '@front/model'
import { MaterialSymbolIcon } from '../components/terros/icon/MaterialSymbolIcon'
import { NotificationPanel } from './NotificationPanel'

export function NotificationBell(): ReactElement | null {
  const [opened, setOpened] = useState(false)
  const [view, setView] = useState<NotificationView>('unread')
  const count = useNotificationUnreadCount()
  const badge = count.data && count.data.count > 0 ? count.data.display : undefined
  function close(): void {
    setOpened(false)
  }
  if (count.unavailable || (!count.available && isNotDefined(count.error))) return null
  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position='bottom-end'
      width='min(420px, calc(100vw - 24px))'
      shadow='md'
      trapFocus
      returnFocus
    >
      <Popover.Target>
        <Indicator label={badge} disabled={isNotDefined(badge)} color='red' size={SizePrimitives[5]}>
          <ActionIcon
            variant='subtle'
            color='white'
            aria-label={isNotDefined(badge) ? 'Notifications' : `Notifications, ${badge} unread`}
            aria-expanded={opened}
            onClick={(): void => setOpened(!opened)}
          >
            <MaterialSymbolIcon icon='notifications' />
          </ActionIcon>
        </Indicator>
      </Popover.Target>
      <Popover.Dropdown
        aria-label='Notifications'
        style={{ '--notification-row-surface': 'light-dark(var(--mantine-color-white), var(--mantine-color-dark-6))' }}
      >
        {opened && <NotificationPanel onOpen={close} view={view} onViewChange={setView} />}
      </Popover.Dropdown>
    </Popover>
  )
}
